module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_02_6NX26_1SF_H2U.b9533df2.jpg";